'use strict';

var updateMiniCart = true;
var $miniCart = $('.minicart');
var $miniCartIcon = $('.minicart .minicart-icon');
var $miniCartPopOver = $('.minicart-overlay-wrapper');
const $expHeader = $('.experience-header');
const $body = $('body');
var $miniCartQuantity = $('.minicart .minicart-quantity');

/**
 * Function to render the fallback content
 */
function showFallbackContent() {
    var fallbackContainer = $('.minicart-recommended-section.product-category');
    var carouselContainer = $('.recommendations-minicart');

    if (fallbackContainer.length && carouselContainer.length) {
        carouselContainer.show();
        carouselContainer.find('h4').addClass('show');
        fallbackContainer.hide();
    }
}

/**
 * Function to check if Einstein Carousel is empty and show fallback
 */
function checkEinsteinCarousel() {
    setTimeout(function () {
        var carouselItems = $('.recommandation-carousel .recommendation .product-tile');

        if (carouselItems.length !== 0) {
            showFallbackContent();
        }
    }, 100);
}

/**
 * Updates the quantity in UI.
 */
const updateMiniCartQuantityUI = function () {
    $('.minicart-overlay-wrapper')
        .find('.cart-lineitem-qty-wrapper')
        .each(function () {
            const $container = $(this);
            const inputVal = $container.find('.quantity').val();
            if (inputVal) {
                $container.find('.cart-lineitem-qty-value').text(inputVal);
            }
        });
};

const miniCartClick = function () {
    $miniCartIcon.on('click', function (event) {
        event.preventDefault();
        $miniCartPopOver.spinner().start();
        if ($('.minicart-overlay-wrapper').hasClass('hide-header') && !$('.search-results-container').length) {
            $body.addClass('minicart-with-hide-header');
        }
        $body.trigger('minicart:update');
    });
};

const miniCartUpdate = function () {
    let minicartLoading = false;
    $body.on('minicart:update', function () {
        if (!updateMiniCart) {
            $(document).trigger('openSlider', {
                target: '#minicart-overlay-slider',
            });
            $miniCartPopOver.spinner().stop();
            return;
        }
        if (minicartLoading) return;
        minicartLoading = true;
        var url = $miniCart.data('action-url');
        $.spinner().start();
        $.get(url, function (data) {
            $('.minicart-overlay-wrapper').remove();
            $body.removeClass('slider-open');
            $body.trigger('carousel:setup', {});
            $miniCart.append(data);
            if ($('.minicart-overlay-wrapper .product-summary .card').length === 0) {
                $miniCart.find('.empty-mini-cart').addClass('active slider-animate');
                $miniCart.find('.has-items').remove();
            } else {
                $miniCart.find('.has-items').addClass('active slider-animate');
                $miniCart.find('.empty-mini-cart').remove();
            }
            if (!$('.cart-page').length && !$('.product-add-to-cart-success-toaster').is(':visible')) {
                $(document).trigger('openSlider', {
                    target: '#minicart-overlay-slider',
                });
                $('.minicart').addClass('minicart-open');
                if ($('.minicart').hasClass('minicart-open') && $expHeader.hasClass('hide-header')) {
                    $expHeader.addClass('hide-header-with-minicart-open');
                    $('.product-detail .sticky-atb-bar').addClass('hide-header-with-minicart-open');
                    $body.addClass('slider-open');
                } else if ($('.minicart').hasClass('minicart-open')) {
                    $body.addClass('slider-open');
                } else if ($('.minicart-overlay-wrapper').hasClass('hide-header')) {
                    $body.addClass('minicart-with-hide-header');
                } else {
                    $expHeader.removeClass('hide-header-with-minicart-open');
                    $('.product-detail .sticky-atb-bar').removeClass('hide-header-with-minicart-open');
                }
                $('body').trigger('gtm:trigger:event', { eventId: $miniCart.find('#gtmEventDetails').attr('data-event') });
            }
            updateMiniCartQuantityUI();
            minicartLoading = false;
            updateMiniCart = false;
            $.spinner().stop();
            checkEinsteinCarousel();
        });
    });
};

const miniCartCountUpdate = function () {
    $('.minicart').on('count:update', function (event, count) {
        if (count && $.isNumeric(count.quantityTotal) && count.quantityTotal > 0) {
            $miniCartQuantity.removeClass('d-none');
            $miniCartQuantity.text(count.quantityTotal);
            $('.minicart .minicart-link').attr({
                'aria-label': count.minicartCountOfItems,
                title: count.minicartCountOfItems,
            });
        }
    });

    $('.minicart').off('mouseenter focusin touchstart');
};

const miniCartRemoveProduct = function () {
    $body.on('click', '.minicart .js-remove-product', function () {
        const $this = $(this);
        let actionUrl = $this.data('action');
        let productID = $this.data('pid');
        let uuid = $this.data('uuid');
        const $deleteConfirmBtn = $('.remove-product-modal .cart-delete-confirmation-btn');
        $deleteConfirmBtn.attr('data-pid', productID);
        $deleteConfirmBtn.attr('data-action', actionUrl);
        $deleteConfirmBtn.attr('data-uuid', uuid);
    });
};

const miniCartOverlayButtonRedirection = function () {
    $body.on('click', '.minicart .minicart-footer a', function () {
        var url = $(this).attr('href');
        window.location.href = url;
    });
};

const miniCartOverlayClose = function () {
    $body.on('click', '.minicart-overlay-wrapper .slider-overlay, .minicart-overlay-wrapper .slider-close', function () {
        $expHeader.removeClass('hide-header-with-minicart-open');
        $miniCart.removeClass('minicart-open');
        $body.removeClass('minicart-with-hide-header');
        $body.removeClass('move-to-wishlist-modal-open');
    });
};

const minicartUpdateInit = function () {
    $body.on('product:beforeAddToCart cart:beforeUpdate', function () {
        updateMiniCart = true;
    });
};

const miniCartCountClick = function () {
    $body.on('click', '.minicart-link', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $body.trigger('minicart:update');
    });
};

module.exports = {
    updateMiniCartQuantityUI: updateMiniCartQuantityUI,
    miniCartClick: miniCartClick,
    miniCartCountUpdate: miniCartCountUpdate,
    miniCartRemoveProduct: miniCartRemoveProduct,
    miniCartOverlayButtonRedirection: miniCartOverlayButtonRedirection,
    miniCartOverlayClose: miniCartOverlayClose,
    miniCartUpdate: miniCartUpdate,
    minicartUpdateInit: minicartUpdateInit,
    miniCartCountClick: miniCartCountClick,
};
